import { RefObject, useEffect, useRef, useState } from 'react';

export default function useActiveSectionIndex(ref: RefObject<HTMLDivElement>) {
  const [activeId, setActiveId] = useState<string | null>(null);

  const activeIdRef = useRef(activeId);
  activeIdRef.current = activeId;

  useEffect(() => {
    if (typeof window === 'undefined' || !ref.current) {
      return () => {};
    }
    const titles = Array.from(
      ref.current.querySelectorAll<HTMLHeadingElement>('h2[id]')
    );
    const titlesAndOffsets = titles.map(
      (title) => [title.id, title.offsetTop] as const
    );

    const handler = () => {
      const scroll =
        document.body.scrollTop || document.documentElement.scrollTop;
      let nextId: string | null = null;
      titlesAndOffsets.forEach(([title, offset]) => {
        const leadingTrigger = offset + window.innerHeight / 3;
        const bottomScreen = scroll + window.innerHeight;
        if (bottomScreen > leadingTrigger) {
          nextId = title;
        }
      });
      if (activeIdRef.current !== nextId) {
        const url = new URL(window.location.href);
        if (nextId && window.location.hash !== nextId) {
          url.hash = nextId;
        } else if (!nextId) {
          url.hash = '';
        }
        window.history.replaceState({}, '', url.toString());
        setActiveId(nextId);
      }
    };
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return activeId;
}
